import { GlobalContext } from '@/context';
import { API, PATH } from '@/data';
import { DateString, RestAPI } from '@/scripts';
import { BrandRankingType, BrandType, PaginationType } from '@/types';
import { useContext, useEffect, useState } from 'react';
import styles from './reviews.module.scss';
import { Pagination, Spin } from 'antd';
import { TbArrowBack, TbArrowNarrowDown, TbArrowNarrowUp } from 'react-icons/tb';
interface Review {
  brand: BrandType;
  brand_category: BrandRankingType<'list'>;
  comment?: string;
  created_at: string;
  id: number;
  like?: boolean;
  user: string;
}
export default function RankingReviewsComp(props: {
  brand: BrandType;
}) {
  const {
    langText,
    location
  } = useContext(GlobalContext);
  const lang = langText.brandDetail;
  const [reviewsList, setReviewsList] = useState<{
    data: PaginationType<Review>;
    page: number;
  }>();
  const getComments = (page: number) => {
    setReviewsList(undefined);
    RestAPI.get<PaginationType<Review>>(API.ranking.votes, {
      page_size: 4,
      page,
      brand__slug: props.brand.slug,
      has_comment: true,
      ordering: '-created_at'
    }).then(res => setReviewsList({
      data: res.data,
      page
    }))
    // .catch(() => message.error(lang.errorMessage));
    .catch(() => setReviewsList({
      page,
      data: {
        num_of_pages: 1,
        count: 0,
        data: []
      }
    }));
  };
  useEffect(() => getComments(1), []);
  return <>
            <div className={`${styles['ranking-reviews']} mb-10 ${reviewsList?.data.count === 0 ? 'd-none-i' : ''}`}>
                <span className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="t-h3 t-800 t-dark1">{lang.rankingComments}</h3>
                    <p className="t-p1 t-400 t-dark3">
                        {reviewsList?.data.count} {lang.commentsForBrand}
                    </p>
                </span>
                {!reviewsList ? <div className={`w-100 pv-6 center-content ${styles['loading']}`}>
                        <Spin />
                    </div> : <div className={`${styles['card-list']} flex-wrap`}>
                        {reviewsList.data.data.map((item, index) => <div key={index} className={`${styles['review']} flex-1`}>
                                <div className={`${styles['header']} ph-1 align-items-center justify-content-between`}>
                                    <div className="gap-16 align-items-center">
                                        {item.like === true ? <span className={`center-content ${styles['vote-item']} ${styles['up']}`}>
                                                <TbArrowNarrowUp size={20} className="t-white" />
                                            </span> : item.like === false ? <span className={`center-content ${styles['vote-item']} ${styles['down']}`}>
                                                <TbArrowNarrowDown size={20} className="t-white" />
                                            </span> : null}
                                        <p className="t-700 t-dark1 ltr">{item.user}</p>
                                    </div>
                                    <span className="t-dark4 t-p2">
                                        {item.created_at ? DateString(item.created_at, '{Y:4}/{M:2}/{D:2}', langText.lang) : ''}
                                    </span>
                                </div>
                                <div className={`${styles['comment']}`}>
                                    <p dangerouslySetInnerHTML={item.comment ? {
              __html: item.comment
            } : undefined} className={item.comment ? 'mb-2' : 'd-none'} />
                                    {item.brand_category.category ? <a target="_blank" href={PATH(langText.lang).services.category(location.slug, item.brand_category.category?.slug)} className="t-500 t-p1 t-primary center-content-y gap-8">
                                            <TbArrowBack size={20} />
                                            {item.brand_category.category.title}
                                        </a> : null}
                                </div>
                            </div>)}
                        <div className={`${styles['review']} ${styles['spacer']} flex-1`} />
                    </div>}
            </div>
            <div className={`${styles['pagination-review-layout']} ${(reviewsList?.data.num_of_pages ?? 0) > 1 ? '' : 'd-none'} center-content`}>
                <div className={`${styles['pagination-review']} d-flex center-content`}>
                    <Pagination size="small" current={reviewsList?.page} pageSize={4} total={reviewsList?.data.count} showSizeChanger={false} hideOnSinglePage onChange={getComments} data-sentry-element="Pagination" data-sentry-source-file="reviews.index.tsx" />
                </div>
            </div>
        </>;
}